import React from 'react'
import { EditingItemProps, useClearEditingItem } from 'utils/commonHooks'
import { LogTemplateProps, useInitLog } from 'utils/log'

import ActionArea, { ActionAreaProps } from '../RequestTemplate/ActionArea'
import FooterArea from '../RequestTemplate/FooterArea'
import GlobalFooterArea from '../RequestTemplate/GlobalFooterArea'
import GlobalHeaderArea from '../RequestTemplate/GlobalHeaderArea'
import MapArea, { MapAreaProps } from './MapArea'

/**
 * 位置選択画面用テンプレート
 */
const MapTemplate: React.FC<MapTemplateProps> = (props) => {
  useInitLog(props.title)
  useClearEditingItem(props.notClearEditingItem)

  return (
    <React.Fragment>
      <GlobalHeaderArea />
      <MapArea
        title={props.title}
        usingLocationName={props.usingLocationName}
        usingGeolocation={props.usingGeolocation}
        usingMultiSearch={props.usingMultiSearch}
        mapHeight={props.mapHeight}
        location={props.location}
        setLocation={props.setLocation}
        setIsDisabled={props.setIsDisabled}
        fixedMarkers={props.fixedMarkers}
        markerComponent={props.markerComponent}
        searchResultMarkerComponent={props.searchResultMarkerComponent}
        addressComponent={props.addressComponent}
      />
      <ActionArea
        forwardLabel={props.forwardLabel}
        forwardAction={props.forwardAction}
        forwardTo={props.forwardTo}
        isDisabled={props.isDisabled}
        disabledLabel={props.disabledLabel}
        showBack={props.showBack}
        backLabel={props.backLabel}
        backAction={props.backAction}
        backTo={props.backTo}
      />
      <FooterArea />
      <GlobalFooterArea />
    </React.Fragment>
  )
}

export type MapTemplateProps = LogTemplateProps &
  MapAreaProps &
  ActionAreaProps &
  EditingItemProps

export default MapTemplate
